const binding = { modules: {}, dataActions: {} };

    (binding.modules['container-with-header'] = {
        c: () => require('partner/modules/container-with-header/container-with-header.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'container-with-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/container-with-header'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };